import { useContext, useEffect, useState } from 'react';

import fetchApI from '../utils/fetchApi';
import HeaderContext from '../context/HeaderContext';

type TUseCounter = {
  badgeName: string;
  badgeKey?: string;
  endpoint?: string;
};

function useCounter(initialState: number, options: TUseCounter): number {
  const [counter, setCounter] = useState(initialState);
  const { badgeKey = '', badgeName, endpoint } = options || {};

  // try to use counters from context when available.
  const { customCounters = {} } = useContext(HeaderContext) || {};
  useEffect(() => {
    if (!endpoint) return;

    const fetchCounter = async () => {
      try {
        const res = await fetchApI(endpoint);

        setCounter(res[badgeKey]);
      } catch (error) {
        // eslint-disable-next-line no-console
      }
    };

    fetchCounter();
  }, [badgeKey, badgeName, endpoint]);

  return customCounters[badgeKey] ?? counter;
}

export default useCounter;
